
const decimalFormatter = new Intl.NumberFormat(undefined, {style: 'decimal', maximumFractionDigits: 2});
const integerFormatter = new Intl.NumberFormat(undefined, {style: 'decimal', maximumFractionDigits: 0});

export const formatDecimalNumber = (value: number | undefined | null) => {
    if (value === undefined || value === null) {
        return "";
    }
    return decimalFormatter.format(value);
};

export const formatIntegerNumber = (value: number | undefined | null) => {
    if (value === undefined || value === null) {
        return "";
    }
    return integerFormatter.format(value);
};
